const headers = {
  name: "Debit Notes",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "filter",
      name: "supplier",
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "Supplier",
      api: "get-all-suppliers",
      value: null,
      options: null,
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
    {
      type: "add",
      path: "/app/purchases/debit-notes/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "LPO",
        path: "/app/purchases",
      },
      {
        name: "GRN",
        path: "/app/purchases/grn",
      },
      {
        name: "Voucher",
        path: "/app/purchases/voucher",
      },
      {
        name: "Returns",
        path: "/app/purchases/returns",
      },
      {
        name: "Debit Notes",
        path: "",
      },
      {
        name: "MRN",
        path: "/app/purchases/mrn",
      },
      {
        name: "MIN",
        path: "/app/purchases/min",
      },
    ],
    total: [
      { value: 0, label: "Total" },
      { value: 0, label: "Active" },
      { value: 0, label: "Inactive" },
    ],
  },
};

export default headers;
